import Skills from "./skills";

export default Skills;
